<svelte:options tag='swc-modal' immutable={true} />

<script>

  import { get_current_component } from 'svelte/internal';
  import { initEventDispatcher } from '../helpers/init-event-dispatcher';

  const dispatch = initEventDispatcher(get_current_component());
  const overlayClicked = () => dispatch('close');
  const modalClicked = (event) => event.stopPropagation();

</script>

<style>

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal {
  position: fixed;
  background: #FFFFFF;
  text-align: center;
  border-radius: 4px;
  padding: 44px 64px 46px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 11px 15px -7px,
    rgba(0, 0, 0, 0.14) 0px 24px 38px 3px,
    rgba(0, 0, 0, 0.12) 0px 9px 46px 8px;
  width: 350px;
  max-width: 90vw;
}

</style>

<div class='overlay' on:click={overlayClicked}>
  <div class='modal' on:click={modalClicked}>
    <slot name='content'></slot>
  </div>
</div>
